import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero__inner">
          <nav className="about-hero__breadcrumb">
            <Link to="/">Home</Link>
            <span className="about-hero__breadcrumb-sep">/</span>
            <span className="about-hero__breadcrumb-current">About</span>
          </nav>
          <h1 className="about-hero__title">The LPA Company</h1>
        </div>
      </section>

      {/* About The LPA Company */}
      <section className="about-section about-section--white">
        <div className="about-section__inner">
          <div className="about-profile">
            <div className="about-profile__info">
              <p className="about-profile__text">
                The LPA Company is dedicated to helping individuals and families plan confidently
                for the future by providing clear, practical guidance on Lasting Powers of Attorney
                and related private client matters. The firm focuses on making what can often seem
                like a complex process straightforward, reassuring, and professionally managed from
                start to finish.
              </p>
              <p className="about-profile__text">
                The company operates through Lossos &amp; Co. Ltd and is led by Charles Lossos, a
                Qualified Solicitor since 2003 (SRA Registration No: 317477). As Managing Director,
                Charles ensures that every matter is handled with the highest level of professionalism,
                care, and attention to detail.
              </p>
              <p className="about-profile__text">
                The LPA Company maintains strict professional and ethical standards. Clients can
                expect a service that is both thorough and approachable, designed to provide clarity
                and peace of mind when making important decisions about the future.
              </p>
              <p className="about-profile__text">
                Whether assisting individuals, families, or business owners, The LPA Company is
                committed to delivering personalised advice and a reliable, professional service.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="about-cta__inner">
          <h2 className="about-cta__title">Get in Touch</h2>
          <p className="about-cta__desc">
            Whether you are considering an LPA for the first time or have questions about the
            process, we are here to help. Get in touch for a personal, no-obligation
            conversation.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
